<template>
    <IntegrationBox
        :active="active"
        title="Teams"
        :name="integration?.name"
        documentation-url=""
        integration-type="Webhook"
        @openNew="$emit('openNew')"
        @openEdit="$emit('openEdit')"
        @openRemove="$emit('openRemove')"
    >
        <template #logo>
            <TeamsLogo class="h-10 w-[50px]" />
        </template>
    </IntegrationBox>
</template>

<script lang="ts" setup>
import type { IIntegration, ITeams } from "@/types/Integrations/IIntegration";
import type { PropType } from "vue";

defineEmits(["openNew", "openEdit", "openRemove"]);

defineProps({
    disabled: {
        type: Boolean,
        default: false,
    },
    active: {
        type: Boolean,
        required: false,
        default: false,
    },
    integration: {
        type: Object as PropType<IIntegration<ITeams>>,
        required: false,
        default: () => ({}),
    },
});
</script>
